import React from 'react'
import { slotToTime } from '../data/seed'

/**
 * Wear OS: vista agenda in stile Calendario Samsung (One UI).
 * Card arrotondate, fascia oraria, accento colore a sinistra.
 */
export function BlockListWatch({ timeboxes, types }) {
  if (!timeboxes?.length) {
    return (
      <div className="watch-calendar-wrap">
        <div className="watch-calendar-empty">
          <span className="watch-calendar-empty-icon" aria-hidden>📅</span>
          <p>Nessun evento oggi</p>
        </div>
      </div>
    )
  }

  return (
    <div className="watch-calendar-wrap">
      <ul className="watch-calendar-list" aria-label="Agenda">
        {timeboxes.map(tb => {
          const type = types.find(ty => ty.id === tb.typeId) ?? { label: tb.typeId, color: '#5c6bc0' }
          const len = tb.lengthSlots ?? 1
          const startTime = slotToTime(tb.startSlot)
          const endSlot = tb.startSlot + len
          const endTime = slotToTime(endSlot)
          const timeRange = len > 1 ? `${startTime} – ${endTime}` : startTime
          return (
            <li
              key={tb.id}
              className="watch-calendar-event"
              style={{ '--event-color': type.color }}
            >
              <span className="watch-calendar-event-bar" aria-hidden />
              <div className="watch-calendar-event-body">
                <span className="watch-calendar-event-time">{timeRange}</span>
                <span className="watch-calendar-event-title">{type.label}</span>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
